import Vue from 'vue'

Vue.filter('integrationType', type => {
  if (type === 'smartsupp') return 'Smartsupp'

  return type
})
